// This file added by Bearer Web Developer
import React from "react";
import styles from "./latestPickup.module.scss";
import BearerDateField from "../../../../../components/fields/BearerDateField";
import BearerOptionsField from "../../../../../components/fields/BearerOptionsField";
import { observer } from "mobx-react-lite";
import { useAppState } from "../../../../../states/app-state";
import getNextSomeDays from "../../../../../app/getNextSomeDays";
import { validateLatestDate, validateLatestTime } from "./validation";
import { getValidateTimes } from "../../../../../states/scheduleOrderstate";

const LatestPickup: React.FC = observer(() => {
    const appstate = useAppState();
    const scheduleOrder = appstate?.selectedOrder?.scheduleOrder;
    const minimumLatestDate = (earliestDate?: string, earliestTime?: string) => {
        const times = getValidateTimes(earliestDate, earliestTime, 2);
        if (times.length === 0) {
            const nextDayOfEarliest = getNextSomeDays(1, earliestDate);
            return nextDayOfEarliest;
        }
        return earliestDate;
    };
    return (
        <div className={styles.latest_pickup}>
            <h4>Latest Pickup:</h4>
            <div className={styles.input_part}>
                <BearerDateField
                    value={scheduleOrder?.latestDate}
                    min={minimumLatestDate(scheduleOrder?.earliestDate, scheduleOrder?.earliestTime)}
                    max={getNextSomeDays(7)}
                    onChange={(e) => scheduleOrder?.setLatestDate(e.target.value)}
                    validator={validateLatestDate}
                    withoutLabel={true} name="latest-date" colorStyle="dark-blue" />
            </div>
            <div className={styles.input_part}>
                <BearerOptionsField
                    withoutLabel={true}
                    notNeededmptyValue={true}
                    name="latest-time"
                    value={scheduleOrder?.latestTime}
                    colorStyle="dark-blue"
                    options={
                        scheduleOrder?.latestTimeOptions.map(time => ({ label: time, value: time })) || []
                    }
                    onChange={(e) => scheduleOrder?.setLatestTime(e.target.value)}
                    validator={validateLatestTime}
                />
            </div>
            {
                scheduleOrder?.latestTime === '' && scheduleOrder?.latestDate === '' &&
                <div className={styles.validation_message}>
                    Please select a valid earliest pickup time for latest pickup time.
                </div>
            }
        </div>
    )
})
export default LatestPickup;